import React from 'react';


export default function Barcode(props)
{
	const style = {
		pointerEvents: props.pointerEvents ? props.pointerEvents : "none",
	}

	//render
	return (
		<button className='checklistPreviewButton' style={style} onClick={(e)=>
		{
			if(props.onChangeCallback)
			{
				props.onChangeCallback('barcode taken');
			}
		}}>Scan Barcode</button>
	)
}